export const SET_DATE_FIELD_ACTION = '@notasFiscais/SET_DATE_FIELD_ACTIONS';
export const SET_BUSCAR_DADOS_TABELA = '@notasFiscais/SET_BUSCAR_DADOS_TABELA';
export const SET_SIMPLE_NOTAS_FISCAIS_ACTION = '@notasFiscais/SET_SIMPLE_NOTAS_FISCAIS_ACTION';
export const SET_COMMON_ACTION = '@notasFiscais/SET_COMMON_ACTION';
export const LIST_IDS = '@notasFiscais/LIST_IDS';
export const SET_EXPORTAR_NOTAS_FISCAIS = '@notasFiscais/SET_EXPORTAR_NOTAS_FISCAIS';
export const SET_CANCELAR_NOTA_FISCAL = '@notasFiscais/SET_CANCELAR_NOTA_FISCAL';
